import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const SurveyApi = {
    get: (webinarId: string, options?: BaseApiQueryOptions) => apiQueryOptions(['survey', 'get', webinarId], (api) => api.survey.get(webinarId), options),
    update: (options?: BaseApiMutationOptions<ApiClient['survey']['update']>) => apiMutationOptions((api) => api.survey.update, options)
};
